<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
    <el-form
      :model="form"
      :rules="rules"
      ref="caseForm"
      label-width="120px"
      class="case-form"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所在部门">
            <el-input
              v-model="form.department"
              placeholder="所在部门由系统自动填充"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所在项目">
            <el-input
              v-model="form.project"
              placeholder="所在项目由系统自动填充"
              readonly
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="案件归属">
            <el-input
              v-model="form.work_company_name"
              placeholder="案件归属"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单账龄">
            <span v-if="order_type == 1">当期</span>
            <span v-else-if="order_type == 2">纯上年</span>
            <span v-else-if="order_type == 3">一年以上两年以内</span>
            <span v-else-if="order_type == 4">两年以上</span>
            <span v-else-if="order_type == 5">一年以上</span>
            <span v-else-if="order_type == 6">历史</span>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 案件详情表格 -->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="案件详情">
            <el-table
              :data="tableData"
              style="width: 100%"
              border
              :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
            >
              <el-table-column
                prop="HouseName"
                label="房产名称"
                width="200"
                :formatter="formatHouseName"
              >
              </el-table-column>
              <el-table-column
                prop="plaintiff"
                label="原告方"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.plaintiff"
                    placeholder="请输入原告方"
                    size="small"
                    :disabled="scope.row.is_case == 1"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="defendant"
                label="被告方"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.defendant"
                    placeholder="请输入被告方"
                    size="small" :disabled="scope.row.is_case == 1"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                label="案件金额"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.legal_money"
                    disabled
                    size="small"
                  >
                    <template slot="append">元</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="court"
                label="管辖法院/仲裁委"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.court_id" :disabled="scope.row.is_case == 1">
                    <el-option v-for="item in court_list" :key="item.court_id" :value="item.court_id" :label="item.name">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="claims"
                label="诉讼请求"
                min-width="300"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.claims"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入诉讼请求"
                    size="small" :disabled="scope.row.is_case == 1"
                  />
                </template>
              </el-table-column>
              <el-table-column label="关联订单">
                <template slot-scope="scope">
                  <el-link type="primary" @click="showOrder(scope.row)">查看订单</el-link>
                </template>
              </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_case">已录案</span>
                  <span v-else>未录案</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
    </el-dialog>

    <!-- 订单列表弹框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="orderDialogVisible"
      width="80%"
      :before-close="handleOrderDialogClose"
    >
      <div style="margin-bottom: 15px; font-size: 16px; font-weight: bold; color: #303133;">
        欠费总额 ：￥ {{ totalArrearsAmount }}
      </div>
    <el-table
      :data="orderListData"
      style="width: 100%"
      border
      :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
    >
      <el-table-column
        prop="house_name"
        label="房产"
      >
      </el-table-column>
      <el-table-column
        prop="charge_item"
        label="收费项目"
      >
      </el-table-column>
      <el-table-column
        prop="billing_start_time"
        label="计费开始时间"
      >
      </el-table-column>
      <el-table-column
        prop="billing_end_time"
        label="计费结束时间"
      >
      </el-table-column>
      <el-table-column
        prop="receivable_amount"
        label="应收金额"
      >
        <template slot-scope="scope">
          ¥{{ scope.row.receivable_amount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="received_amount"
        label="已收金额"
      >
        <template slot-scope="scope">
          ¥{{ scope.row.received_amount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="arrears_amount"
        label="欠费金额"
      >
        <template slot-scope="scope">
          ¥{{ scope.row.arrears_amount }}
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleOrderDialogClose">关闭</el-button>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment/moment";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: 'CaseForm',
  props: {
    // 接收房产列表参数
    house_list: {
      type: Array,
      default: () => []
    },
    // 控制弹窗显示的属性
    visible: {
      type: Boolean,
      default: false
    },
    // 订单账龄
    order_type : {
      type : Number ,
      default : 5,
    },
  },
  data() {
    return {
      dialogVisible: false,
      orderDialogVisible: false,  // 订单列表弹框显示状态
      form: {
        department: '',           // 所在部门
        project: '',              // 所在项目
        ownership: ''             // 案件归属
      },
      court_list : [],            // 法院列表
      tableData: [],              // 表格数据
      orderListData: [],          // 订单列表数据
      rules: {}
    }
  },
  computed: {
    dialogTitle() {
      return this.form.id ? '编辑案件' : '新增案件';
    },
    // 计算欠费总额
    totalArrearsAmount() {
      if (!this.orderListData || this.orderListData.length === 0) {
        return 0;
      }
      return this.orderListData.reduce((sum, order) => {
        const amount = parseFloat(order.arrears_amount) || 0;
        return sum + amount;
      }, 0).toFixed(2);
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.resetForm();
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.handleClose();
      }
    },
  },
  methods: {
    // 格式化房产名称
    formatHouseName(row) {
      return row.HouseName;
    },

    submitForm() {
      let that = this
      // 验证表单基本信息
      this.$refs.caseForm.validate((valid) => {
        let post_params = {
          project_id : this.form.project_id ,
          department_id : this.form.department_id ,
          work_company_id : this.form.work_company_id ,
          house_list : []
        }
        this.tableData.forEach(house => {
          if(!house.is_case){
            let order_ids = [];
            house.order_list.forEach(order => {
              order_ids.push(order.id);
            });

            post_params.house_list.push({
              house_id : house.HouseID ,
              customer_id : house.customer_id ,
              plaintiff : house.plaintiff ,
              defendant : house.defendant ,
              legal_money : house.legal_money ,
              agreement_id : house.agreement_id ,
              agreement_md5 : house.ch_md5 ,
              // court : house.court ,
              claims : house.claims,
              court_id : house.court_id ,
              order_ids : order_ids
            });
          }
        })

        if(!post_params.house_list.length){
          that.$message.error('没有未录案案件可以提交！');
          return false;
        }


        if (valid) {
          ButlerHttp.post("LawCase/saveLawCase", post_params, res => {
            if (res.code) {
              that.$message.success('案件已提交成功，线下自行填写诉讼文件，无需重复申请盖章，请及时向法院提交立案申请!')
              that.handleClose();
            } else {
              that.$message.error(res.msg);
            }
          });
        } else {
          console.log('表单验证失败!');
          return false;
        }
      });
    },
    handleCancel() {
      this.handleClose();
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('update', false); // 同步父组件的visible状态
    },
    resetForm() {
      let params_house_list = [];
      this.house_list.forEach(house => {
        params_house_list.push({
          house_id : house.HouseID ,
          customer_id : house.customer_id ,
        });
      })
      ButlerHttp.post("LawCase/getHouseLegalList", {
        project_id: this.house_list[0].PrecinctID,
        order_type : this.order_type,
        house_list : params_house_list
      }, res => {
        if (res.code) {
          // 法院列表
          this.court_list = res.data.court_list;

          this.tableData = [];
          res.data.house_list.forEach(house => {
            house.plaintiff = res.data.work_company.company_name;
            this.tableData.push(house);
          })
          // this.tableData = res.data.house_list;
          this.form = {
            department: res.data.department.department_name ,
            department_id : res.data.department.id ,
            project: res.data.project_info.name,
            project_id : res.data.project_info.id,
            work_company_id : res.data.work_company.id,
            work_company_name : res.data.work_company.company_name ,
          };
        } else {
          that.$message.error(res.msg);
        }
      });

      this.$refs.caseForm && this.$refs.caseForm.resetFields();
      this.form = {
        department: '',
        project: '',
        ownership: ''
      };
      this.tableData = [];
    },
    toDate(timestamp){
      // 秒时间戳转日期格式
      return moment(timestamp * 1000).format('YYYY-MM-DD');
    },
    showOrder(row){
      if(row.order_list && row.order_list.length > 0){
        // 处理订单数据格式
        this.orderListData = row.order_list.map(order => ({
          house_name: order.house_name || row.HouseName || '',
          charge_item: order.charge_name || '',
          billing_start_time: this.toDate(order.startDate),
          billing_end_time: this.toDate(order.endDate),
          receivable_amount: order.charge,
          received_amount: order.PaidChargeSum,
          arrears_amount: (parseFloat(order.charge) - parseFloat(order.PaidChargeSum) + parseFloat(order.adjust)).toFixed(2),
        }));
        this.orderDialogVisible = true;
      } else {
        this.$message.warning('该案件暂无关联订单信息');
      }
    },
    handleOrderDialogClose(){
      this.orderDialogVisible = false;
      this.orderListData = [];
    },
  }
}
</script>

<style scoped>
.case-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.case-form /deep/ .el-form-item {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}

/deep/ .el-table .el-table__row {
  td {
    padding: 5px 0;
  }

  .cell {
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_form.vue